<template>
    <div class="dashboard loading-content-container">
        <div v-if="!preferencesLoaded" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <div v-show="preferencesLoaded">
        <b-row class="mb-3">
            <b-col cols="12">
                <div class="float-right">
                <b-form-checkbox v-if="preferencesLoaded" v-model="displayDamageRecordsOfFirm"
                                 :switch="true"
                                 :unchecked-value="0"
                                 :value="1"
                                 @change="saveDashboardPreferences">
                    <span>
                        Nur eigene Akten
                    </span>
                </b-form-checkbox>
                </div>
            </b-col>
        </b-row>
        <b-row
            v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordApprovedOverview')
                || hasPermission('Csp_Dashboard_Widget_DamageRecordEditStatus')">
            <b-col v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordApprovedOverview')" cols="6">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    :disable-pagination="true"
                    icon="inticon-autoclaim_files"
                    :items-ajax-url="dashboardRepository.getDamageRecordApprovedOverviewUrl()"
                    :legacy-data-structure="true"
                    table-headline="Angenommene / eigenbearbeitete Schadenakten"/>
            </b-col>
            <b-col v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordEditStatus')" cols="6">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    :disable-pagination="true"
                    icon="inticon-autoclaim_user"
                    :items-ajax-url="dashboardRepository.getDamageRecordEditStatusUrl()"
                    :legacy-data-structure="true"
                    table-headline="Schadenaktenbearbeitung aktuell"/>
            </b-col>
        </b-row>
        <b-row v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordOverdueInquiry')" class="mt-4">
            <b-col cols="12">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_phone-landline"
                    item-detail-id-label="damageRecordId"
                    :item-detail-url="dashboardRepository.getDamageRecordItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordOverdueInquiryUrl()"
                    :legacy-data-structure="true"
                    table-headline="Unerledigte Rückfragen"/>
            </b-col>
        </b-row>
        <b-row
            v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordStatus')
                || hasPermission('Csp_Dashboard_Widget_DamageRecordNoteInquiry')"
            class="mt-4">
            <b-col v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordStatus')" cols="5">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    :disable-pagination="true"
                    icon="inticon-autoclaim_files"
                    :items-ajax-url="dashboardRepository.getDamageRecordStatusUrl()"
                    :legacy-data-structure="true"
                    table-headline="Schadenaktenstatus"/>
            </b-col>
            <b-col v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordNoteInquiry')" cols="7">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_phone-landline"
                    item-detail-id-label="damageRecordId"
                    :item-detail-url="dashboardRepository.getDamageRecordItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordNoteInquiryUrl()"
                    :legacy-data-structure="true"
                    table-headline="Offene Rückfragen"/>
            </b-col>
        </b-row>
        <b-row v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordNoteReminder')" class="mt-4">
            <b-col cols="12">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_calendar"
                    item-detail-id-label="damageRecordId"
                    :item-detail-url="dashboardRepository.getDamageRecordItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordNoteReminderUrl()"
                    :legacy-data-structure="true"
                    table-headline="Wiedervorlagen/Fristen"/>
            </b-col>
        </b-row>
        <b-row v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordInactivity')" class="mt-4">
            <b-col cols="12">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_attention"
                    item-detail-id-label="vehicleDamageRecordId"
                    :item-detail-url="dashboardRepository.getDamageRecordItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordInactivityUrl()"
                    :legacy-data-structure="true"
                    table-headline="Inaktive Schadenakten"/>
            </b-col>
        </b-row>
        <b-row v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordInactiveFirms') && isReseller"
            class="mt-4">
            <b-col cols="12">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_assign"
                    item-detail-id-label="firmId"
                    :item-detail-url="dashboardRepository.getFirmItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordInactiveFirmsUrl()"
                    :legacy-data-structure="true"
                    table-headline="Inaktive Firmen"/>
            </b-col>
        </b-row>
        <b-row v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordNewFiles')" class="mt-4">
            <b-col cols="12">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_document_accident"
                    item-detail-id-label="vehicleDamageRecordId"
                    :item-detail-url="dashboardRepository.getDamageRecordItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordNewFilesUrl()"
                    :legacy-data-structure="true"
                    table-headline="Neue Dokumente"/>
            </b-col>
        </b-row>
        <b-row v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordInactiveFirms') && !isReseller"
            class="mt-4">
            <b-col cols="12">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_assign"
                    item-detail-id-label="firmId"
                    :item-detail-url="dashboardRepository.getFirmItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordInactiveFirmsUrl()"
                    :legacy-data-structure="true"
                    table-headline="Inaktive Firmen"/>
            </b-col>
        </b-row>
        <b-row v-if="hasPermission('Csp_Dashboard_Widget_DamageRecordOverdueReminder')" class="mt-4">
            <b-col cols="12">
                <csp-table
                    :default-page-options="pageOptions"
                    :default-per-page="perPage"
                    icon="inticon-autoclaim_calendar"
                    item-detail-id-label="damageRecordId"
                    :item-detail-url="dashboardRepository.getDamageRecordItemDetailUrl()"
                    :items-ajax-url="dashboardRepository.getDamageRecordOverdueReminderUrl()"
                    :legacy-data-structure="true"
                    table-headline="Überfällige Wiedervorlagen/Fristen"/>
            </b-col>
        </b-row>
    </div>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import '@desktop/scss/components/dashboard.scss';
    const container = Container.getInstance();
    const dashboardRepository = container.getDesktopDashboardRepository();
    const ajaxService = container.getAjaxService();

    export default {
        name: 'Dashboard',
        data() {
            return {
                dashboardRepository: dashboardRepository,
                widgets: [],
                isReseller: false,
                perPage: 5,
                pageOptions: [5, 10, 20, 30, 50, 200],
                preferencesUrl: null,
                displayDamageRecordsOfFirm: 0,
                preferencesLoaded: false,
            };
        },
        computed: {
            hasPermission() {
                return (permission) => {
                    return this.widgets.includes(permission);
                };
            },
        },
        created() {
            this.dashboardRepository.getDashboardPermissions().then((response) => {
                this.widgets = response.data.meta.permissions.widgets;
                this.isReseller = response.data.meta.permissions.isReseller;
            });
        },
        mounted() {
            this.dashboardRepository.getDashboardPreferencesUrl().then((response) => {
                this.preferencesUrl = response.preferencesUrl;
                this.displayDamageRecordsOfFirm = response.preferences?.board?.displayDamageRecordsOfFirm ?? 0;
                this.preferencesLoaded = true;
            });
        },
        methods: {
            saveDashboardPreferences() {
                this.preferencesLoaded = false;
                const formData = new FormData();
                formData.append('preference[board][displayDamageRecordsOfFirm]', this.displayDamageRecordsOfFirm);

                ajaxService.postFormDataPlainAjax(this.preferencesUrl, formData)
                    .then(() => {
                        window.location.reload();
                    })
            },
        },
    };
</script>
